<template>
  <!-- 活动资料管理 -->
  <el-dialog
    class="dialog-activity-info"
    title="活动资料管理"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <!-- 列表内容 -->
    <div class="content">
      <div class="button">
        <el-row>
          <!-- 上传 -->
          <cmp-upload
            ref="myUpload"
            :businessType="`activity`"
            :callEveryFun="uploadCallback"
            :conacat="false"
          ></cmp-upload>
          <!-- 导出 -->
          <!-- <cmpMyExport
            class="ml-20"
            @clearSelectsCall="clearSelectsCall"
            :chooseIds="chooseRowIds"
            :chooseApi="`/scheme/exportScheme?arr=`"
            :searchApi="`/scheme/exportSchemeAll?schemeName=`+form.schemeName+`&schemeNumber=`+form.schemeNumber+`&planYear=`+form.planYear+`&dataState=`+form.dataState"
          ></cmpMyExport>-->
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table
          ref="multipleTable"
          v-loading="listLoading"
          stripe
          :row-key="(row)=>{ return row.schemeId }"
          :data="tableData"
          @selection-change="handleSelectionChange"
        >
          <!-- <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column> -->
          <el-table-column prop="fileName" label="附件名称" min-width="15%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="fileFormat" label="格式" min-width="7%"></el-table-column>
          <el-table-column prop="fileShowSize" label="大小" min-width="12%"></el-table-column>
          <el-table-column prop="fileDownCount" label="下载次数" min-width="8%"></el-table-column>
          <el-table-column label="更新时间" min-width="10%">
            <template slot-scope="scope">{{ scope.row.updateDate | DateFormat('yyyy-MM-dd') }}</template>
          </el-table-column>

          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="16%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click.stop="addFile(scope.row, '重命名文件')">重命名</a>

              <a class="m-btn mr-10" @click.stop="downLoad(scope.row)">下载</a>

              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination
            :current-page="listQuery.currentPage"
            :page-size="listQuery.size"
            :total="total"
            background
            layout="total, prev, pager, next, sizes, jumper"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import cmpMyExport from '@cmp/my-export'
import cmpUpload from '@cmp/my-upload/index'
export default {
  components: { cmpMyExport, cmpUpload },
  data() {
    return {
      dialogVisible: false,
      id: '', // 活动id
      // form: {},
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      tableData: [],
      listLoading: true,
      chooseRowIds: '' // 当前导出选中藏品id
    }
  },
  methods: {
    init(id) {
      this.id = id
      this.dialogVisible = true
      this.initList()
    },
    // 初始化表格
    initList(type) {
      this.listLoading = true
      this.$http
        .get('/bsActivityFiledata/getFileListById', {
          ...this.listQuery,
          key: this.id
        })
        .then(res => {
          this.listLoading = false
          if (res.success) {
            if (
              type === 'dele' &&
              this.listQuery.currentPage > 1 &&
              !res.result.length
            ) {
              this.listQuery.currentPage -= 1
              this.initList()
              return
            }
            this.tableData = res.result
            this.total = res.page.allRow
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 上传回调 文件新增
    uploadCallback(item) {
      this.$http
        .post('/bsActivityFiledata/save', {
          id: this.id, //	项目ID
          fileId: item.attId //	文件夹名称
        })
        .then(res => {
          if (res.success) {
            this.restList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 创建文件夹
    addFile(item, title) {
      let strName = item.fileName
      this.$prompt('', title || '创建文件夹', {
        showClose: true,
        showCancelButton: false,
        confirmButtonText: '确定',
        inputValue: strName || null,
        inputPlaceholder: '文件名称',
        // inputPattern: /^[\S]{1,50}$/,
        inputPattern: /^.{1,50}$/,
        inputErrorMessage: '请输入1到50位字符'
        // center: true
      })
        .then(({ value }) => {
          if (strName) {
            this.modifyRemote(item, value)
          } else {
            this.addRemote(item, value)
          }
        })
        .catch(() => {})
    },
    addRemote(item, value) {},
    // 重命名文件夹
    modifyRemote(item, value) {
      // 文件类型(0:文件,1:文件夹)
      this.$http
        .put('/bsActivityFiledata/renameFile', {
          id: item.id, //	文件id
          fileRealname: value //	文件新名称
        })
        .then(res => {
          if (res.success) {
            this.$message.success('重命名文件成功')
            this.initList()
          } else {
            this.$message.error(res.message)
          }
        })
    },

    // 下载
    downLoad(item) {
      location.href = '/singleMuseum/bsActivityFiledata/download?id=' + item.id
    },

    // 重置查询
    restList() {
      // this.$refs['form'].resetFields()
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.initList()
    },

    // 删除
    handleDelete(item) {
      this.$common.confirm(
        {
          title: '您正在删除资料，是否确认删除？',
          className: 'cus-confirm-375'
        },
        () => {
          this.$http
            .delete('/bsActivityFiledata/deleteFile', {
              id: item.id
            })
            .then(res => {
              if (res.success) {
                this.$message.success('资料删除成功')
                this.initList('dele')
              } else {
                this.$message.error(res.message)
              }
            })
        }
      )
    },

    handleSelectionChange(list) {
      let arr = []
      list.forEach(item => {
        arr.push(item.id)
      })
      this.chooseRowIds = arr.join(',')
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.initList()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.initList()
    },
    // 清空选中状态
    clearSelectsCall() {
      this.$refs.multipleTable.clearSelection()
    }
  }
}
</script>


<style lang="scss" scoped>
.dialog-activity-info {
  .content {
    min-height: 300px;
  }
}
</style>